import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { SupplierService } from 'src/app/services/supplier/supplier.service';
import { FlashMessageService } from 'src/app/shared/services/flash-message.service';
import { ModalService } from 'src/app/shared/services/modal.service';
import { DeleteCustomerSupplierXrefComponent } from './delete-customer-supplier-xref/delete-customer-supplier-xref.component';
import { ActionConfirmationModalComponent } from 'src/app/shared/components/action-confirmation-modal/action-confirmation-modal.component';
import { MatDialog } from '@angular/material/dialog';
import * as _ from 'lodash';
import { DeleteSupplierXrefModal } from 'src/assets/data/delete-supplier-xref-modal';
import { CustomerService } from 'src/app/services/customer/customer.service';
import { AddSupplierCustomerComponent } from 'src/app/components/customers/add-supplier-customer/add-supplier-customer.component';

@Component({
  selector: 'app-supplier-associations',
  templateUrl: './supplier-associations.component.html',
  styleUrls: ['./supplier-associations.component.scss']
})
export class SupplierAssociationsComponent implements OnInit {

  public loading: boolean = false;
  public filterSearch;
  public p: any;
  public isLoading: boolean;

  @Input()
  customers: any;

  @Input()
  selected: any;

  @Input()
  isMobile: any;

  @Input()
  supplier: any;

  @Output() associationsCount = new EventEmitter();


  constructor(private supplierService: SupplierService,
    private _flashMessageSvc: FlashMessageService,
    private _customerSvc: CustomerService,
    private modalService: ModalService,
    public dialog: MatDialog) { }

  ngOnInit() {}

  /**
   * To turn on/off release status
   * @param releaseStatus
   * @param xref
   */
  public onAllowRelease(releaseStatus, xref) {
    let payload = {
      suppID: xref.supplier_id,
      custID: xref.erp_customer_id,
      allowRelease: releaseStatus
    };
    this.supplierService.updateReleaseStatus(payload)
      .then((xref) => {
        this._flashMessageSvc.updateMessage(`Schedule Shipment turned ${xref['allow_release'] ? 'on' : 'off'} for ${xref['erp_customer_id']}`, 3000, 'success');
      })
      .catch((e) => {
        this._flashMessageSvc.updateMessage('Schedule Shipment was not saved');
      });
  }

  /**
   * if selected customer has customer_supplier_ids > 1 then open DeleteCustomerSupplierXrefComponent
   * else open ActionConfirmationModalComponent
   * @param customer selected customer obj
   * @param i index
   */
  public unlinkCustomer(customer: any, i: number) {
    if (customer.customer_supplier_ids && customer.customer_supplier_ids.length > 1) {
      this.modalService.open(DeleteCustomerSupplierXrefComponent, customer);
    } else {
      let modalMessage = _.cloneDeep(DeleteSupplierXrefModal);
      modalMessage.headerText = modalMessage.headerText.replace("{{customer_supplierId}}", (customer.customer_supplier_ids && customer.customer_supplier_ids.length && customer.customer_supplier_ids[0] ? customer.customer_supplier_ids[0] : ""));
      this.modalService.open(ActionConfirmationModalComponent, { data: modalMessage });
    }

    /**
     * close event will get data from modal to patent component when modal is closed
     * Based on the customer index, we updated the customer_supplier_ids of the respective customer in the parent component(app-supplier-associations) in the UI
     */
    let subscribe = this.modalService.closeEvent.subscribe(result => {
      if (result['sourceComponent'] === 'DELETE') {
        if (result.data.customer_supplier_ids && result.data.customer_supplier_ids.length) {
          this.customers.customers[i].customer_supplier_ids = result.data.customer_supplier_ids;
        } else {
          this.customers.customers.splice(i, 1);
          this.associationsCount.emit({event: 'decrement', count: this.customers.customers.length});
        }
      } else {
        if (result.event === 'Confirm') {
          this._deleteCustomerSupplierId(customer, i);
        }
      }
      subscribe.unsubscribe();
    });
  }

  /**
   * _deleteCustomerSupplierId is called when we have(one/no customer_supplier_id in the array)
   * and it will remove the xref record in mongo. Updates the UI to remove the xref record based on index
   * @param customer obj
   * @param i index
   */
  private _deleteCustomerSupplierId(customer: any, i: number) {
    const payload = {
      suppID: customer.supplier_id,
      custID: customer.erp_customer_id,
      custSupID: customer.customer_supplier_ids.length > 0 ? customer.customer_supplier_ids[0] : ""
    }
    this.supplierService.unlinkCustomer(payload)
      .then((data) => {
        this._flashMessageSvc.updateMessage('Successfully deleted customer', 2000, 'success');
        if (i > -1) {
          this.customers.customers.splice(i, 1);
          this.associationsCount.emit({event: 'decrement', count: this.customers.customers.length});
        }
      })
      .catch(() => {
        this._flashMessageSvc.updateMessage('Not able to unlink customer');
      })
  }

  onAddCustomer() {
    this.modalService.open(AddSupplierCustomerComponent, this.customers.customers);
    let subscribe = this.modalService.closeEvent.subscribe(result => {
      if (result) {
      const payload = {
        custID : result[0].erpCustomerID,
        suppID: this.supplier
      };
      this.supplierService.linkCustomer(payload).then(xrefAdded => {
        xrefAdded['customerDetails'] = { name : result[0].custname };
        this.customers.customers.push(xrefAdded);
        this.associationsCount.emit({event: 'increment', count: this.customers.customers.length});
      }).catch(err => {
        this._flashMessageSvc.updateMessage('Failed to Add Customer.Please try again in sometime');
      });
      }
      subscribe.unsubscribe();
    });
  }
}
